import * as React from 'react';

function SvgExclamationCircle(props) {
  return (
    <svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#exclamation-circle_svg__clip0_2504_44405)">
        <path
          d="M6 .75a5.25 5.25 0 100 10.5A5.25 5.25 0 006 .75zm-.375 2.719c0-.052.042-.094.094-.094h.562c.052 0 .094.042.094.094v3.187a.094.094 0 01-.094.094H5.72a.094.094 0 01-.094-.094V3.47zM6 8.625A.563.563 0 016 7.5a.563.563 0 010 1.125z"
          fill="#6B92F3"
        />
      </g>
      <defs>
        <clipPath id="exclamation-circle_svg__clip0_2504_44405">
          <path fill="#fff" d="M0 0h12v12H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgExclamationCircle;
